/*!
 * vue-control-hint v0.10.17 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { generator } from '@aspectus/vue-bem-styled-tag';
import { Tag } from '@aspectus/vue-tag';
import { createBlockGenerator, createStateGenerator } from '@aspectus/bem';

var name = 'control-hint';
var b = createBlockGenerator();
var s = createStateGenerator();
var Hint = Object.assign(generator({
  block: b(name),
  state: s,
  tag: Tag
}), {
  name: name
});

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? Hint.name : _ref$name;

  Vue.component(name, Hint);
}
var main = {
  install: install
};

export default main;
export { Hint, install };
